// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.concierge-create-supplier-option {
  color: var(--color-neutral-dark);
  font-size: 16px;
  font-weight: 500;
}
.concierge-create-supplier-option .concierge-create-supplier-icon {
  margin-left: var(--spacing-extra-small);
  font-size: 18px;
  color: var(--color-highlight);
}
.concierge-create-supplier-option span {
  color: var(--color-highlight);
  font-weight: 700;
}
.concierge-create-supplier-option:hover {
  color: var(--color-neutral-dark-lighter);
}
.concierge-create-supplier-option:hover span {
  color: var(--color-highlight-lighter);
}
.concierge-create-supplier-upload-row {
  margin-top: var(--spacing-regular);
}
@media (max-width: 425px) {
  .collum-btn-concierge {
    width: 100% !important;
  }
  .collum-btn-concierge button {
    display: flex;
    align-items: center;
    flex-direction: row !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Concierge/Components/SupplierInformation.less"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;AACF;AAJA;EAMI,uCAAA;EAEA,eAAA;EACA,6BAAA;AAAJ;AATA;EAaI,6BAAA;EACA,gBAAA;AADJ;AAKA;EACE,wCAAA;AAHF;AAEA;EAII,qCAAA;AAHJ;AAOA;EACE,kCAAA;AALF;AASA;EACE;IACE,sBAAA;EAPF;EAMA;IAII,aAAA;IACA,mBAAA;IACA,8BAAA;EAPJ;AACF","sourcesContent":[".concierge-create-supplier-option {\n  color: var(--color-neutral-dark);\n  font-size: 16px;\n  font-weight: 500;\n\n  .concierge-create-supplier-icon {\n    margin-left: var(--spacing-extra-small);\n\n    font-size: 18px;\n    color: var(--color-highlight);\n  }\n\n  span {\n    color: var(--color-highlight);\n    font-weight: 700;\n  }\n}\n\n.concierge-create-supplier-option:hover {\n  color: var(--color-neutral-dark-lighter);\n\n  span {\n    color: var(--color-highlight-lighter);\n  }\n}\n\n.concierge-create-supplier-upload-row {\n  margin-top: var(--spacing-regular);\n}\n\n\n@media(max-width: 425px){\n  .collum-btn-concierge {\n    width: 100% !important;\n\n    button{\n      display: flex;\n      align-items: center;\n      flex-direction: row !important;\n\n    }\n  }\n} \n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
